<template>
	<v-container>
		<h5>2.4.1</h5>
		<video controls>
			<source src="usermanual/editroute6a.mp4" type="video/mp4">
		</video>
	</v-container>
</template>

<script>
	export default {
		name: 'EditRoute9a'
	}
</script>